const API = process.env.REACT_APP_ADMIN_API_URL || 'https://api.euro.taxi/api/admin';

const getToken = () => localStorage.getItem('adminToken') || '';

export const req = async (method, path, body) => {
  try {
    const r = await fetch(API + path, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-admin-token': getToken()
      },
      body: body ? JSON.stringify(body) : undefined
    });

    const text = await r.text();
    let data = {};

    if (text) {
      try {
        data = JSON.parse(text);
      } catch {
        data = { error: text };
      }
    }

    if (r.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUsername');
      window.location.reload();

      const error = new Error(data?.error || 'Platnost přihlášení vypršela.');
      error.status = 401;
      error.data = data;
      throw error;
    }

    if (!r.ok) {
      const message =
        (typeof data?.error === 'string' && data.error) ||
        (typeof data?.message === 'string' && data.message) ||
        `HTTP chyba ${r.status}`;

      const error = new Error(message);
      error.status = r.status;
      error.data = data;
      throw error;
    }

    return data;
  } catch (e) {
    console.error('API error:', e);
    throw e;
  }
};

export const login = async (username, password) => {
  const r = await fetch(API + '/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password })
  });
  return r.json();
};
